import api from '@/api';
import request from '@/lib/request';
import { setToken, clearToken } from "./token";
import _ from 'lodash';
import { Message } from 'element-ui';
import { getGlobalData } from '@/lib/globalData';
import store from '@/store';

//执行退出登录
export const userLogout = () => {
  const globalData = getGlobalData();
  clearToken();
  globalData.clear();
  localStorage.clear();
  sessionStorage.clear();
  store.dispatch('setUserAuth', null);
  store.dispatch('setTopNewmsg', 0);
  store.dispatch('setTopUser', {
    weixin: 0,
    douyin: 0,
  });
};

//执行用户登录
export const userLogin = async (params) => {
  let success = true;
  const { err, res } = await request.post(api.user.LOGIN, params);
  let token = _.get(res, 'data.token'); //如果登录成功就能获取到token
  if (err) { //登录失败
    // Message.error(err);
    success = false;
    userLogout();
  } else if (token) { //登录成功
    token = decodeURIComponent(token);
    setToken(token);
  } else {
    success = false;
  }
  return { success, err, res };
};

//okta登录 获取地址
export const oktaGetAddress = async () => {
  const { res } = await request.get(api.user.okta.GET_ADDRESS, {});
  const url = _.get(res, 'data.url');
  return url;
};


//获取图形验证码
// export const getCaptcha = async (data) => {
//     const { res } = await request.get(api.user.GETCAPCODE, data);
//     return res;
// };

//获取用户信息
export const getUserInfo = async (onerror) => {
  const { res, err } = await request.get(api.user.GET_USER_INFO);
  const userInfo = _.get(res, 'data');
  if (typeof onerror === 'function' && err) {
    onerror(err);
  }
  return userInfo;
};


//新增用户
export const addUser = async (data) => {
  const { err } = await request.post(api.user.ADD, data);
  const success = !err;
  err && Message.error(err);
  return success;
};

//新增omg用户
export const addOmgUser = async (data) => {
  const { err } = await request.post(api.user.ADD_OMG_ACCOUNT, data);
  const success = !err;
  err && Message.error(err);
  return success;
};

//删除用户
export const delUser = async (uid) => {
  const { err } = await request.get(api.user.DEL, { uid });
  const success = !err;
  err && Message.error(err);
  return success;
};

// 编辑用户
export const updateUser = async (data) => {
  const { err } = await request.post(api.user.UPDATE, data);
  const success = !err;
  err && Message.error(err);
  return success;
};

//修改自己的密码
export const updateSelfPassword = async (password) => {
  let params = {};
  if (typeof password === 'string') {
    params.password = password;
    params.repass = password;
  } else if (password && typeof password === 'object') {
    params = Object.assign(params, password);
  }
  const { err } = await request.post(api.user.UPDATE_SELF_PASSWORD, params);
  const success = !err;
  err && Message.error(err);
  return success;
};


//重置密码
export const userResetPassword = async (uid) => {
  const { err } = await request.post(api.user.RESET_PASSWORD, { uid });
  const success = !err;
  err && Message.error(err);
  return success;
};

//用户绑定企业微信
export const userBindWxWork = async ({ uid, userid }) => { //uid用户id  userid企业微信id
  const params = {};
  params.uid = uid;
  params.userid = userid;
  const { err } = await request.post(api.user.BIND_WX_WORK, params);
  const success = !err;
  err && Message.error(err);
  return success;
};

//用户解绑企业微信
export const userUnBindWxWork = async (uid) => { //uid用户id  userid企业微信id
  const params = {};
  params.uid = uid;
  const { err } = await request.post(api.user.UNBIND_WX_WORK, params);
  const success = !err;
  err && Message.error(err);
  return success;
};

//获取抖音授权信息
export const getUserDouYinAuthInfo = async () => {
  const { res } = await request.post(api.user.GET_DOUYIN_AUTH_INFO);
  return _.get(res, 'data');
};

//切换门店
export const switchChannel = async (id) => {
  const params = {};
  params.id = id;
  const { err, res } = await request.post(api.user.SWITCH_CHANNEL, params);
  const success = !err;
  err && Message.error(err);
  if (success) {
    const token = _.get(res, 'data.token');
    token && setToken(token);
  }
  return success;
};

//绑定智能客服
export const userBindAisbot = async (uid) => { //uid用户id
  const params = {};
  params.uid = uid;
  const { err } = await request.post(api.user.BIND_AISBOT, params);
  const success = !err;
  err && Message.error(err);
  return success;
};

//解绑智能客服
export const userUnBindAisbot = async (uid) => { //uid用户id
  const params = {};
  params.uid = uid;
  const { err } = await request.post(api.user.UNBIND_AISBOT, params);
  const success = !err;
  err && Message.error(err);
  return success;
};
